import React from "react";
import PropTypes from "prop-types";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useStyles } from "./QuizResult.styles";

const QuizResult = ({ correctWord, guessedWord, options }) => {
  const classes = useStyles();
  const isCorrect = guessedWord === correctWord;

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <p
          className={`${classes.resultText} ${
            isCorrect ? classes.correct : classes.incorrect
          }`}
        >
          {isCorrect ? (
            <>
              <CheckCircleIcon style={{ fontSize: 28 }} />
              Correct
            </>
          ) : (
            "Incorrect"
          )}
        </p>
        <p className={classes.subtitle}>
          {isCorrect ? (
            "You got it right!"
          ) : (
            <>
              The correct answer is <strong>{correctWord}</strong>
            </>
          )}
        </p>
      </div>
      <div className={classes.grid}>
        {options.map((option, idx) => (
          <div
            key={idx}
            className={`${classes.gridItem} ${
              option === correctWord
                ? classes.correctAnswer
                : classes.wrongAnswer
            }`}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};

QuizResult.propTypes = {
  correctWord: PropTypes.string.isRequired,
  guessedWord: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default QuizResult;
